import { getUserToken } from '@go-client/lib/auth';
import { groupResourceContract } from '../../../../shared/contracts/groupResource';
import { getApiUrlv2, initApiClient } from '@go-client/lib/api';

export const groupResourceClient = initApiClient(groupResourceContract, {
  baseUrl: getApiUrlv2(),
  baseHeaders: {
    'Content-Type': 'application/json',
    'authorization': () => `Bearer ${getUserToken()}`,
  },
});
